var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 57.143,
    viewBox: "0 0 50 57.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37523",
    "data-name": "Group 37523",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35306",
    "data-name": "Path 35306",
    d: "M99.571,0A3.582,3.582,0,0,0,96,3.571v50a3.582,3.582,0,0,0,3.571,3.571h35.714a3.582,3.582,0,0,0,3.571-3.571V14.286L124.571,0Z",
    transform: "translate(-56.857)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35307",
    "data-name": "Path 35307",
    d: "M355.571,14.286h10.714L352,0V10.714A3.582,3.582,0,0,0,355.571,14.286Z",
    transform: "translate(-284.286)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35308",
    "data-name": "Path 35308",
    d: "M394.714,138.714,384,128h10.714Z",
    transform: "translate(-312.714 -113.714)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35309",
    "data-name": "Path 35309",
    d: "M74.857,259.643a1.791,1.791,0,0,1-1.786,1.786H33.786A1.791,1.791,0,0,1,32,259.643V241.786A1.791,1.791,0,0,1,33.786,240H73.071a1.791,1.791,0,0,1,1.786,1.786Z",
    transform: "translate(0 -213.214)",
    fill: "#576d7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37522",
    "data-name": "Group 37522",
    transform: "translate(37.775 32.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35310",
    "data-name": "Path 35310",
    d: "M84.73,305.352a.9.9,0,0,1-.986-.886v-8.109a.97.97,0,0,1,.986-.886H88c6.525,0,6.38,9.88.127,9.88Zm.9-8.139v6.4H88c3.855,0,4.025-6.4,0-6.4Z",
    transform: "translate(-83.744 -295.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35311",
    "data-name": "Path 35311",
    d: "M185.144,302.652a4.986,4.986,0,0,1-5.384-5.141,5.247,5.247,0,0,1,10.495,0A4.979,4.979,0,0,1,185.144,302.652Zm-.157-8.523a3.385,3.385,0,1,0,3.4,3.384A3.268,3.268,0,0,0,184.987,294.129Z",
    transform: "translate(-169.044 -292.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35312",
    "data-name": "Path 35312",
    d: "M288.848,298.293a4.806,4.806,0,0,1,5.013-5.125,4.666,4.666,0,0,1,3.27,1.271.926.926,0,1,1-1.271,1.341,2.464,2.464,0,0,0-2-.784,3.085,3.085,0,0,0-3.254,3.3,3.14,3.14,0,0,0,3.254,3.4,3.335,3.335,0,0,0,2.229-.914.958.958,0,0,1,1.312.171.985.985,0,0,1-.157,1.341,4.67,4.67,0,0,1-3.386,1.116C290.405,303.407,288.848,301.048,288.848,298.293Z",
    transform: "translate(-265.957 -293.068)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35313",
    "data-name": "Path 35313",
    d: "M129.929,417.786H96v1.786h33.929a1.791,1.791,0,0,0,1.786-1.786V416A1.791,1.791,0,0,1,129.929,417.786Z",
    transform: "translate(-56.857 -369.571)",
    fill: "#cad1d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/DOCS.684e2e9c52dae67b026b21d580a0a984.svg";
export { ForwardRef as ReactComponent };